import { render, staticRenderFns } from "./SelectTaskDialog.vue?vue&type=template&id=398d7a9b&scoped=true&"
import script from "./SelectTaskDialog.vue?vue&type=script&lang=js&"
export * from "./SelectTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectTaskDialog.vue?vue&type=style&index=0&id=398d7a9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d7a9b",
  null
  
)

export default component.exports